import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

/**
 * Phase 1 stores. Keyed on the storefront's own ShopifyStore
 * (`regionLocale.store`), never `getBaseStore()` — the UK's base store is EU,
 * and using that would leave the UK on the legacy stack.
 */
export const NEXT_STACK_STORES: readonly ShopifyStore[] = [
  ShopifyStore.US,
  ShopifyStore.CA,
  ShopifyStore.GB,
];

export type AnalyticsStack = 'next' | 'legacy';

export function resolveAnalyticsStack(
  store: ShopifyStore | string | null | undefined,
): AnalyticsStack {
  return NEXT_STACK_STORES.includes(store as ShopifyStore) ? 'next' : 'legacy';
}

/** Country code the storefront contributes to the consent policy. */
export function storefrontCountry(
  store: ShopifyStore | string | null | undefined,
): 'US' | 'CA' | 'GB' | null {
  if (store === ShopifyStore.US) return 'US';
  if (store === ShopifyStore.CA) return 'CA';
  if (store === ShopifyStore.GB) return 'GB';
  return null;
}
